import {Directive, ElementRef, Input, OnInit} from '@angular/core';

@Directive({
  selector: '[LoadingText]'
})
export class LoadingButtonDirective implements OnInit {

    @Input('loadingTextValue') text: string;
    @Input('text') label: string;
    @Input('loadingTextWhen') condition: boolean;
  
    constructor(private elem: ElementRef) {}
  
    ngOnInit() {
        const button = this.elem.nativeElement;
        if (this.text) {
            if (this.condition) {
                button.innerText = this.text;
            }
        }
    }
  
    ngOnChanges(changes) {
      this.condition = changes.condition.currentValue;
      const button = this.elem.nativeElement;
      if (this.text) {
        if (this.condition) {
            button.innerText = this.text;
            button.setAttribute('disabled', 'true');
            button.setAttribute('icon', 'pi pi-spin pi-spinner');
        } else {
            button.innerText = this.label;
            button.removeAttribute('disabled');
            button.removeAttribute('icon');
        }
      }
    }
  }